import { useGameContainer } from '../index';
import styles from './styles/GameWatchLive.module.scss';
import LocalizedDate from 'components/LocalizedDate';
import { ContestExpectedStatusEnum } from 'queries';
import CalloutModule from '@/components/modules/CalloutModule';
import NFHSButtonV2 from '@/components/affiliates/NFHSButtonV2';
import NFHSPlayoffs from '@/components/affiliates/NFHSPlayoffs';
import setUtmReferrer from 'helpers/setUtmReferrer';

export default function GameWatchLive() {
  const [{ game }] = useGameContainer();

  if (!game.contest?.nfhsNetworkUrl) return null;

  const title =
    game.contest.expectedStatus === ContestExpectedStatusEnum.LIVE || game.statusId === 2
      ? 'Watch Live'
      : game.contest.expectedStatus === ContestExpectedStatusEnum.COMPLETED
        ? 'Watch Replay'
        : 'Watch';
  const isPlayoffs = game.gameTypeLabel === 'Playoffs';
  const buttonTitle = isPlayoffs ? 'Stream Playoff Action' : title;

  return (
    <CalloutModule
      title={title}
      right={isPlayoffs ? <NFHSPlayoffs /> : null}
      topText={<LocalizedDate date={game.date} format="ddd, MMMM D" />}
      entity={game.gameTeams.map(({ team }) => team)}
      bottomText={
        <>
          {game.contest.expectedStatus === ContestExpectedStatusEnum.UPCOMING && <div className={styles.NowStreaming}>Streaming Soon</div>}
          {game.contest.expectedStatus === ContestExpectedStatusEnum.LIVE && <div className={styles.NowStreaming}>Now Streaming</div>}
          {game.contest.expectedStatus === ContestExpectedStatusEnum.COMPLETED && <div className={styles.NowStreaming}>Streaming</div>}
        </>
      }
      footer={<NFHSButtonV2 href={setUtmReferrer(game.contest.nfhsNetworkUrl, 'game_details')}>{buttonTitle} On</NFHSButtonV2>}
    />
  );
}
